"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _queryString = _interopRequireDefault(require("query-string"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var optimizeImageHoc = function optimizeImageHoc(WrappedComponent) {
  var OptimizedImage = /*#__PURE__*/function (_React$Component) {
    _inherits(OptimizedImage, _React$Component);

    var _super = _createSuper(OptimizedImage);

    function OptimizedImage(_props) {
      var _this;

      _classCallCheck(this, OptimizedImage);

      _this = _super.call(this, _props);

      _defineProperty(_assertThisInitialized(_this), "calcPlaceholder", function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

        var srcObject = _this.calcImageSrc(props.src);

        srcObject.q = 0;

        if (props.ratio) {
          srcObject.w = 100;
          srcObject.h = 100 / props.ratio;
        }

        var url = props.src.split('?')[0];
        return "".concat(url, "?").concat(_queryString["default"].stringify(srcObject));
      });

      _defineProperty(_assertThisInitialized(_this), "updateImageSrc", function () {
        var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.src;
        var _this$props = _this.props,
            src = _this$props.src,
            alwaysNewPlaceholder = _this$props.alwaysNewPlaceholder,
            fixedPlaceholder = _this$props.fixedPlaceholder;

        var stateUrl = _this.state.src.split('?')[0];

        var stateParams = _this.state.src.split('?')[1];

        var stateSrcObject = _queryString["default"].parse(stateParams);

        var url = src.split('?')[0];
        var params = src.split('?')[1];

        var srcObject = _objectSpread({
          h: 0,
          w: 0
        }, _queryString["default"].parse(params));

        var newSrcObject = _this.calcImageSrc(src);

        if (!(0, _isEqual["default"])(srcObject, newSrcObject) || stateUrl !== url) {
          var updatedSrc = _this.props.src;

          if (newSrcObject.h && newSrcObject.w) {
            updatedSrc = "".concat(url, "?").concat(_queryString["default"].stringify(newSrcObject));
          }

          if (fixedPlaceholder) {
            placeholder = _this.state.placeholder;
          } else if (alwaysNewPlaceholder || !stateSrcObject.h || !stateSrcObject.w) {
            placeholder = _this.calcPlaceholder();
          }

          if (_this._isMounted && _this.state.src !== updatedSrc) {
            _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
              src: updatedSrc,
              placeholder: placeholder
            }), function () {
              if (_this.props.srcChanged) {
                _this.props.srcChanged();
              }
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "calcImageSrc", function (src) {
        var _this$props2 = _this.props,
            height = _this$props2.height,
            width = _this$props2.width;
        var params = src.split('?')[1];
        var sameSrc = _this.state && src === _this.state.src;

        var srcObject = _objectSpread({
          h: 0,
          w: 0
        }, _queryString["default"].parse(params));

        var nextHeight = height * _this.resolutionFactor;

        if (!sameSrc || srcObject.h < nextHeight) {
          srcObject.h = nextHeight;
        }

        var nextWidth = width * _this.resolutionFactor;

        if (!sameSrc || srcObject.w < nextWidth) {
          srcObject.w = nextWidth;
        }

        return srcObject;
      });

      _defineProperty(_assertThisInitialized(_this), "debouncedUpdateImageSrc", (0, _debounce["default"])(_this.updateImageSrc, 300));

      _this._isMounted = false; // retina ready images

      if (typeof window !== 'undefined' && window.devicePixelRatio > 3) {
        _this.resolutionFactor = 4;
      } else if (typeof window !== 'undefined' && window.devicePixelRatio > 2) {
        _this.resolutionFactor = 3;
      } else {
        _this.resolutionFactor = 2;
      }

      var _placeholder = _props.placeholder;

      if (!_props.placeholder) {
        _placeholder = _this.calcPlaceholder(_props);
      }

      var _url = _props.src.split('?')[0];

      var _params = _props.src.split('?')[1];

      var _srcObject = _objectSpread({
        h: 0,
        w: 0
      }, _queryString["default"].parse(_params));

      var _updatedSrc = "".concat(_url, "?").concat(_queryString["default"].stringify(_srcObject));

      _this.state = {
        src: _updatedSrc,
        placeholder: _placeholder
      };

      if (!_props.width && !_props.height && _placeholder) {
        _this.state.src = _placeholder;
      }

      return _this;
    }

    _createClass(OptimizedImage, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this._isMounted = true;
        this.updateImageSrc(this.state.placeholder);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.alwaysFetch || prevProps.height < this.props.height || prevProps.src !== this.props.src) {
          this.debouncedUpdateImageSrc(this.props.src);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._isMounted = false;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            fixedPlaceholder = _this$props3.fixedPlaceholder,
            alwaysNewPlaceholder = _this$props3.alwaysNewPlaceholder,
            alwaysFetch = _this$props3.alwaysFetch,
            rest = _objectWithoutProperties(_this$props3, ["fixedPlaceholder", "alwaysNewPlaceholder", "alwaysFetch"]);

        var _this$state = this.state,
            src = _this$state.src,
            placeholder = _this$state.placeholder;
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, rest, {
          src: src,
          placeholder: placeholder || src
        }));
      }
    }]);

    return OptimizedImage;
  }(_react["default"].Component);

  OptimizedImage.displayName = "OptimizedImage(".concat(WrappedComponent.displayName, ")");
  OptimizedImage.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
    src: _propTypes["default"].string,
    placeholder: _propTypes["default"].string,
    ratio: _propTypes["default"].number,
    fixedPlaceholder: _propTypes["default"].bool,
    alwaysNewPlaceholder: _propTypes["default"].bool,
    alwaysFetch: _propTypes["default"].bool
  });
  OptimizedImage.defaultProps = _objectSpread(_objectSpread({}, WrappedComponent.defaultProps), {}, {
    fixedPlaceholder: false,
    alwaysNewPlaceholder: false,
    alwaysFetch: false
  });
  return (0, _hoistNonReactStatics["default"])(OptimizedImage, WrappedComponent);
};

var _default = optimizeImageHoc;
exports["default"] = _default;